<template>
  <div class="role-selector">
    <el-select
      class="mb-4 dropdown"
      :value="value"
      @input="handleChange"
      placeholder="เลือกตำแหน่ง"
    >
      <el-option
        v-for="role in roleOptions"
        :key="role.value"
        :label="role.label"
        :value="role.value"
      ></el-option>
    </el-select>
    <div>
      <div
        v-for="featureGroup in allFeatures"
        :key="featureGroup.group_label"
        class="feature-group"
      >
        <span class="group-label">{{ featureGroup.group_label }}</span>
        <div class="feature-list">
          <label
            class="select-input readonly"
            v-for="feature in featureGroup.features"
            :key="feature.id"
          >
            <input type="checkbox" disabled :checked="feature.checked" />
            <span class="checkmark checkbox"></span>
            <span>{{ feature.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as R from "ramda";
import { Select, Option } from "element-ui";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: ["value", "roles"],
  computed: {
    roleOptions() {
      if (!this.roles) {
        return [];
      }

      return this.roles.map(role => {
        const label = `${role.role} - ${role.role_name}`;
        const value = role.role_id;

        return {
          label,
          value
        };
      });
    },
    allFeatures() {
      if (!this.roles) {
        return [];
      }

      let allFeatures = [];
      for (const element of this.roles) {
        for (const subElement of element.admin_features) {
          allFeatures.push({
            feature_id: subElement.feature_id,
            feature_code: subElement.feature_code,
            feature_group: subElement.feature_group
          });
        }
      }

      allFeatures = [
        ...new Map(allFeatures.map(item => [item["feature_id"], item])).values()
      ];

      const grouppedFeatures = R.groupBy(R.prop("feature_group"))(allFeatures);

      const groupOrders = this.getFeatureGroupOrders();

      const resultGroups = groupOrders.map(groupName => {
        const groupItems = grouppedFeatures[groupName];

        if (!groupItems) {
          return;
        }

        const features = groupItems.map(this.pasreFeature);

        return {
          group_label: this.$t(
            `feature.staff.access.${groupName.toLowerCase()}.group_name`
          ),
          features
        };
      });

      return resultGroups;
    },
    roleByIds() {
      if (!this.roles) {
        return {};
      }

      return this.roles.reduce((all, role) => {
        all[role.role_id] = role;

        return all;
      }, {});
    },
    selectedRole() {
      return this.roleByIds[this.value];
    },
    selectedFeatureIds() {
      if (!this.selectedRole) {
        return {};
      }

      return this.selectedRole.admin_features.reduce((all, { feature_id }) => {
        all[feature_id] = true;
        return all;
      }, {});
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("input", value);
    },
    pasreFeature(item) {
      const { feature_id, feature_code, feature_group } = item;

      const id = feature_id;

      const translationKey = `feature.staff.access.${feature_group.toLowerCase()}.${feature_code.toLowerCase()}`;
      let label = this.$t(translationKey);

      if (label === translationKey) {
        label = feature_code.toLowerCase();
      }

      const checked = this.selectedFeatureIds[id];

      return {
        id,
        checked,
        label
      };
    },
    getFeatureGroupOrders() {
      return [
        "NEWS",
        "SERVICE",
        "SUBSCRIPTION",
        "GROUP",
        "HOME_AUTOMATION",
        "EV_PARKING",
        "REFINANCE",
        "SELL_AND_RENT",
        "INSURANCE",
        "MONITORING",
        "RUEJAI_CLUB",
        "JURISTIC_SYSTEM",
        "SAP",
        "REWARD_STORE",
        "MNC",
        "CONFERENCE",
        "SUPER_ADMIN"
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.select-input.readonly {
  cursor: auto;

  input[type="checkbox"] ~ span {
    opacity: 0.3;
  }

  input[type="checkbox"]:checked ~ span {
    opacity: 1;
  }

  .checkmark {
    border-color: transparent;
    background: none;

    &:after {
      border-color: $orange;
    }

    &:hover {
      background: none;
    }
  }
}

.dropdown {
  width: 100%;
}

.feature-group {
  margin-bottom: 10px;
}

.group-label {
  font-weight: bold;
  font-size: 18px;
}

.feature-list {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(200px, 1fr)
  ); // Adjust columns to wrap content with min width
  grid-template-rows: repeat(5, auto); // Limit the number of rows to 5
  grid-auto-flow: column; // Automatically flow items into columns
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/staff/components/RoleSelector.vue